<template>
  <v-icon
    v-if="profileImageUrl === undefined || profileImageUrl === null"
    :size="size"
    >mdi-account-circle</v-icon
  >
  <v-img v-else :src="profileImageUrl"></v-img>
</template>

<script>
export default {
  name: 'ProfileImage',
  props: ['size'],
  computed: {
    profileImageUrl() {
      return this.$store.getters.profileImageUrl
    },
  },
}
</script>

<style scoped></style>
